import { Injectable } from '@angular/core';
import { UIThemeEnum } from '../models/ui.models';
import { environment } from 'src/environments/environment';
import { AvailableLangs, TranslocoService } from '@jsverse/transloco';


@Injectable({
  providedIn: 'root'
})
export class SharedUiService {
  availableLanguages: { id: string; label: string, rtl?: boolean }[] = []
  currentActiveLanguage: { id: string; label: string, rtl?: boolean };
  currentEnvState = environment.tagName;

currentMode: UIThemeEnum = UIThemeEnum.light;
constructor(private translocoService: TranslocoService) {
this.changeCurrentLanguage('en');
}

loadTranslocoConfig() {
  this.availableLanguages = this.translocoService.getAvailableLangs() as { id: string; label: string }[];
  this.currentActiveLanguage = this.availableLanguages.find(lang=> lang.id == this.translocoService.getActiveLang());
  this.checkRTL()


  console.log(this.availableLanguages, this.currentActiveLanguage);
}

changeCurrentLanguage(langId: string) {
  this.translocoService.setActiveLang(langId);
  this.loadTranslocoConfig();
}

checkRTL() {
  if (!!this.currentActiveLanguage?.rtl) {
    this.enableRTL()
  }
  else {
    this.disableRTL();
  }

}
enableRTL() {
    document.documentElement.setAttribute("dir", "rtl");
    document.documentElement.setAttribute("direction", "rtl");
    document.documentElement.style.direction = "rtl";

}
disableRTL() {
  document.documentElement.removeAttribute("dir");
  document.documentElement.removeAttribute("direction");
  document.documentElement.style.direction = null;
}

getCurrentTheme() {
  const documentElement = document.body;
  const currentStatus = documentElement.getAttribute('data-bs-theme');

  return currentStatus === 'dark' ? UIThemeEnum.dark : UIThemeEnum.light;
}

setTheme(theme) {
  const documentElement = document.body;
  documentElement.setAttribute('data-bs-theme', theme);

  this.currentMode = theme == 'dark' ? UIThemeEnum.dark : UIThemeEnum.light
}

enableDarkMode() {
  this.setTheme('dark');
}

enableLightMode() {
  this.setTheme('light');
}

toggleThemeMode() {
  const currentTheme = this.getCurrentTheme();
  if (currentTheme === UIThemeEnum.dark) {
    this.enableLightMode();
  } else {
    this.enableDarkMode();
  }
}

}
